import { PivotTableProps } from 'components/pivot-table/PivotTable'

import { KeyMapping, keyMappings } from '../common/keyMapping-relatorioGerencial'
import { VisibilidadeModeloPersonalizadoEnum } from '../components/modelo-personalizado/form/model-modeloPersonalizadoRelatorioGerencialForm'
import {
  DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument,
  GestanteRelatorioGerencialVacinacaoSelectFieldDocument,
  ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
  PuerperaRelatorioGerencialVacinacaoSelectFieldDocument,
  ViajanteRelatorioGerencialVacinacaoSelectFieldDocument,
} from './../../../../graphql/hooks.generated'
import { RelatorioGerencialVacinacaoModel } from './model-relatorioGerencialVacinacao'

const doseKeyMapping: KeyMapping = {
  keyName: 'Dose',
  formatter: (s: string) => s?.capitalize(),
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: DoseImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
}

const gestanteKeyMapping: KeyMapping = {
  keyName: 'Gestante',
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: GestanteRelatorioGerencialVacinacaoSelectFieldDocument,
}

const puerperaKeyMapping: KeyMapping = {
  keyName: 'Puérpera',
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: PuerperaRelatorioGerencialVacinacaoSelectFieldDocument,
}

const estrategiaVacinacaoKeyMapping: KeyMapping = {
  keyName: 'Estratégia',
  formatter: (s: string) => s?.capitalize(),
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: EstrategiaRelatorioGerencialVacinacaoSelectFieldDocument,
}

const viajanteKeyMapping: KeyMapping = {
  keyName: 'Viajante',
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: ViajanteRelatorioGerencialVacinacaoSelectFieldDocument,
}

const imunobiologicoKeyMapping: KeyMapping = {
  keyName: 'Imunobiológico',
  visibility: VisibilidadeModeloPersonalizadoEnum.PUBLICO,
  queryDocument: ImunobiologicoRelatorioGerencialVacinacaoSelectFieldDocument,
}

export const vacinacaoKeyMapping: PivotTableProps<RelatorioGerencialVacinacaoModel>['keyMapping'] = new Map<
  keyof RelatorioGerencialVacinacaoModel,
  KeyMapping
>([
  ['dose', doseKeyMapping],
  ['imunobiologico', imunobiologicoKeyMapping],
  ['municipio', keyMappings.municipio],
  ['unidadeSaude', keyMappings.unidadeSaude],
  ['nomeProfissional', keyMappings.nomeProfissional],
  ['categoriaProfissional', keyMappings.categoriaProfissional],
  ['equipe', keyMappings.equipe],
  ['turno', keyMappings.turno],
  ['sexo', keyMappings.sexo],
  ['dia', keyMappings.dia],
  ['mes', keyMappings.mes],
  ['hora', keyMappings.hora],
  ['semana', keyMappings.semana],
  ['diaSemana', keyMappings.diaDaSemana],
  ['faixaEtaria', keyMappings.faixaEtaria],
  ['gestante', gestanteKeyMapping],
  ['puerpera', puerperaKeyMapping],
  ['estrategiaVacinacao', estrategiaVacinacaoKeyMapping],
  ['viajante', viajanteKeyMapping],
  ['cbo', keyMappings.cbo],
  ['producoes', keyMappings.producoes],
])
